
import { useMemo } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';

import * as localeMap from 'date-fns/locale';
import * as locales from '@mui/x-date-pickers/locales';

const DatePickerContainer = ({children}) => {
    const { currentLocale } = useOnlineBookingLocale();
    const locale = currentLocale.slice(0, 2);

    
    const localeText = useMemo(()=>{
        for (const key in locales) {
            if (!key.startsWith(locale)) continue;
            const translation = locales[key]?.components?.MuiLocalizationProvider?.defaultProps?.localeText;
            const override = {
                fieldDayPlaceholder: () => 'DD', 
                fieldMonthPlaceholder: params => params.contentType === 'letter' ? 'MMMM' : 'MM',
                fieldYearPlaceholder: params => 'Y'.repeat(params.digitAmount)
            }

            return {...translation, ...override};
        }
    },[locale])
    
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localeMap[locale] || localeMap['enUS']} localeText={localeText}>
            {children}
        </LocalizationProvider>
    )
}

export default DatePickerContainer;